import React, { useCallback, useState } from 'react'
import PropTypes from 'prop-types'
import { makeStyles } from '@material-ui/core'
import { Controller, useForm } from 'react-hook-form'
import SydModal from '../../../../commonDesign/SydModal'
import SaveCancelButtons from '../../../../molecules/SaveCancelButtons'
import SydLabel, { hookFormErrorAdapter } from '../../../../commonDesign/SydLabel'
import SydInput from '../../../../commonDesign/SydInput'
import { useSetBranding } from '../../../../../api/abundanceEngine'

export const modalStyles = makeStyles(() => ({
  root: {
    height: '25rem',
    display: 'flex',
    flexDirection: 'column',
    gap: '1rem'
  },
  inputRow: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    width: '100%'
  },
  buttonRow: {
    width: '100%',
    display: 'flex',
    justifyContent: 'center'
  },
  fullRow: {
    flex: 1
  },
  formLabel: {
    width: '100%'
  },
  errorMessage: {
    color: 'var(--color-danger-500)',
    fontStyle: 'italic',
    margin: '12px 0'
  }
}))

const BrandModal = ({ open, onClose }) => {
  const classes = modalStyles()
  const { mutateAsync: addBrand, isLoading } = useSetBranding()
  const [error, setError] = useState(null)
  const form = useForm({
    mode: 'onChange',
    defaultValues: {
      brandKey: '',
      firmName: '',
      tagLine: '',
      logoUrl: '',
      faviconUrl: ''
    }
  })
  const onSubmit = useCallback(async (data) => {
    setError(null)
    try {
      const result = await addBrand(data)
      if (result && result.success !== false) {
        form.reset()
        onClose()
      }
    } catch (err) {
      console.error('Error saving branding:', err)
      setError(err?.response?.data?.message || err?.message || 'An error occurred while saving')
    }
  }, [onClose, addBrand, form])
  return (
    <SydModal open={open} onClose={onClose} title='Add Branding'>
      <div className={classes.inputRow}>
        <Controller
          name='brandKey'
          control={form.control}
          rules={{ required: { value: true, message: 'Brand key is required' } }}
          render={({ field, fieldState }) => (
            <SydLabel
              label='Brand Key'
              error={hookFormErrorAdapter(form, fieldState)}
            >
              <SydInput {...field} error={fieldState.error} />
            </SydLabel>
          )}
        />

        <Controller
          name='firmName'
          control={form.control}
          rules={{ required: { value: true, message: 'Firm name is required' } }}
          render={({ field, fieldState }) => (
            <SydLabel
              label='Firm Name'
              error={hookFormErrorAdapter(form, fieldState)}
            >
              <SydInput {...field} error={fieldState.error} />
            </SydLabel>
          )}
        />
      </div>
      <div className={classes.inputRow}>
        <Controller
          name='tagLine'
          control={form.control}
          rules={{ required: { value: true, message: 'Tag line is required' } }}
          render={({ field, fieldState }) => (
            <SydLabel
              label='Tag Line'
              error={hookFormErrorAdapter(form, fieldState)}
              className={classes.formLabel}
            >
              <SydInput {...field} error={fieldState.error} />
            </SydLabel>
          )}
        />
      </div>
      <div className={classes.inputRow}>
        <Controller
          name='logoUrl'
          control={form.control}
          rules={{ required: { value: true, message: 'Logo url is required' } }}
          render={({ field, fieldState }) => (
            <SydLabel
              label='Logo URL'
              error={hookFormErrorAdapter(form, fieldState)}
              className={classes.formLabel}
            >
              <SydInput {...field} error={fieldState.error} />
            </SydLabel>
          )}
        />
      </div>
      <div className={classes.inputRow}>
        <Controller
          name='faviconUrl'
          control={form.control}
          rules={{ required: { value: true, message: 'Favicon url is required' } }}
          render={({ field, fieldState }) => (
            <SydLabel
              label='Favicon URL'
              error={hookFormErrorAdapter(form, fieldState)}
              className={classes.formLabel}
            >
              <SydInput {...field} error={fieldState.error} />
            </SydLabel>
          )}
        />
      </div>

      {error && <div className={classes.errorMessage}>{error}</div>}

      <div className={classes.buttonRow}>
        <SaveCancelButtons
          containerClassName={classes.saveCancel}
          onSave={form.handleSubmit(onSubmit)}
          onCancel={onClose}
          isSubmitting={isLoading}
        />
      </div>
    </SydModal>
  )
}

BrandModal.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func
}

export default BrandModal
